export  const CashJob = [
    {
        id: '1',
        label: 'Puncture Repair',
    },
    {
        id: '2',
        label: 'Front Wheel Alignment',
    },
    {
        id: '3',
        label: 'All 4 Wheel Alignment',
    },
    {
        id: '4',
        label: 'Miscellaneous',
    },
    {
        id: '5',
        label: 'Tyres',
    },
    {
        id: '6',
        label: 'A/C Gas- R1234yf',
    },
    {
        id: '7',
        label: 'A/C Gas- R134a',
    },
    {
        id: '8',
        label: 'General Repairs',
    },
]